import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {CircularProgress} from "@mui/material";

function BlurLoading({isGlobal}) {
    const [viewLoading, setViewLoading] = useState(false);

    const {loading} = useSelector((state) => state.transferResponse);
    useEffect(() => {
        if (loading === "idle" && !isGlobal) {
            setViewLoading(false);
        } else if (loading === "pending" && !isGlobal) {
            setViewLoading(true);
        } else if (loading === "globalPending" && isGlobal) {
            setViewLoading(true);
        }
    }, [loading]);


    return (
        <>
            {viewLoading ? (
                <>
                    {
                        isGlobal ?
                            (
                                <div id="diff-click-cont"></div>
                            )
                            :
                            <div id="blurry-cont">
                                <div className="loading">
                                    {/*<img className="suyool-loading" src="/Images/Suyool-Loading.gif"/>*/}
                                    <CircularProgress color="inherit"/>
                                </div>
                            </div>
                    }

                </>
            ) : (
                <></>
            )}
        </>

    );
}

export default BlurLoading;